import { motion, useReducedMotion } from "framer-motion";

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  /**
   * Animate on mount instead of on scroll-into-view. Use this for content
   * that's above the fold — IntersectionObserver-based `whileInView` can
   * miss the initial-mount case on mobile (especially iOS Safari), leaving
   * the hero blank until the user scrolls away and back.
   */
  immediate?: boolean;
}

export const Reveal = ({
  children,
  delay = 0,
  className = "",
  immediate = false,
}: RevealProps) => {
  // Reduced motion: render in place, with no fade or rise.
  if (useReducedMotion()) return <div className={className}>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      {...(immediate
        ? { animate: { opacity: 1, y: 0 } }
        : {
            whileInView: { opacity: 1, y: 0 },
            viewport: { once: true, amount: 0.15 },
          })}
      transition={{ duration: 0.7, delay, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
